'use client';

import { Button } from '@/components/ui/button';
import { ArrowRightIcon, HouseIcon } from '@phosphor-icons/react';
import Image from 'next/image';
import { useRouter } from 'next/navigation';

export default function NotFound() {
  const router = useRouter();

  return (
    <div className="flex flex-row max-w-[1728px] bg-[#8dc0db] justify-center items-center w-full min-h-screen px-8">
      <div className="flex flex-col items-center justify-center text-center">
        {/* Título principal */}
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight mb-6">
          <span className="text-gray-900">¡Ups!</span>{' '}
          <span className="text-white">Página perdida</span>
        </h1>

        {/* Descripción */}
        <p className="text-lg text-gray-600 leading-7 mb-2 max-w-lg">
          No hemos encontrado la página que buscas.
        </p>

        {/* Código de error sutil */}
        <p className="text-sm text-white mb-8 font-semibold">Error 404 • Página no encontrada</p>

        {/* Botones de acción */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Button
            variant="secondary"
            rightIcon={<HouseIcon size={20} />}
            onClick={() => router.push('/')}
          >
            Volver al inicio
          </Button>

          <Button
            variant="primary"
            rightIcon={<ArrowRightIcon weight="bold" size={20} />}
            onClick={() => router.push('/contact-us')}
          >
            Contactar soporte
          </Button>
        </div>
      </div>
      <div className="flex flex-col items-start justify-start h-full">
        <Image
          src="/notFound.jpeg"
          alt="Robot confundido"
          width={800}
          height={800}
          className="w-full h-full object-contain"
          priority
        />
      </div>
    </div>
  );
}
